<item-preview-wrapper 
    class="cportal-info-preview"
    [config]="config"
    [isItem]="isItem"
>
    <item-preview-wrapper_custom-content class="cportal-info-preview__custom-content-section">
        <preview-field class="item-preview-wrapper__preview-field">
            <preview-field_label class="item-preview-wrapper__preview-field-content">
                {{ l10nKeys.portalUrlLabel | vtranslate }}
            </preview-field_label>
            <preview-field_val class="item-preview-wrapper__preview-field-content">
                {{ config.portal_url }}
            </preview-field_val>
        </preview-field>
        <preview-field
            class="item-preview-wrapper__preview-field"
            *ngIf="siteId"
        >
            <preview-field_label class="item-preview-wrapper__preview-field-content">
                {{ l10nKeys.siteIdLabel | vtranslate }}
            </preview-field_label>
            <preview-field_val class="item-preview-wrapper__preview-field-content">
                {{ siteId }}
            </preview-field_val>
        </preview-field>
    </item-preview-wrapper_custom-content>
</item-preview-wrapper>
